import React from 'react';

import cn from 'classnames';
import { MdWarning } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';

import { isLoggedInSel } from '@shared/duck/selectors/general.selectors';

import { goToFeatureFlags } from '../duck/actions';
import { featureFlags } from '../utils/featureFlags';
import styles from './OverridesBanner.styles.less';

export const OverridesBanner: React.FC = () => {
  const isOverriding = featureFlags.isOverriding();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(isLoggedInSel);

  if (!isOverriding) return null;

  return (
    <div
      className={cn(styles.ffOverridesBanner, {
        [styles.withLink]: isLoggedIn,
      })}
      onClick={() => {
        if (!isLoggedIn) return;

        dispatch(goToFeatureFlags());
      }}
    >
      <MdWarning />
      <span>Feature Flags are being overriden</span>
    </div>
  );
};

export default OverridesBanner;
